
const customStyles = {
    control: (base) => ({
        ...base,
        fontSize: '0.8rem',
        minHeight: '30px',
        height: '30px',
       
        boxShadow: null,
  
    }),
    input: (provided, state) => ({
        ...provided,
        margin: '0px',
        overFlow: 'visible',
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        return {
            ...styles,
            fontSize: '0.8rem',
           
            backgroundColor:isFocused ? 'var(--bs-tertiary-bg)':'var(--bs-body-bg)'
        };
    },
    indicatorsContainer: (provided, state) => ({
        ...provided,
        height: '30px',
    }),
    singleValue: (provided, state) => ({
        ...provided,
        overflow: 'none',
    }),
  };
  const the = (theme) => ({
    ...theme,
    borderRadius: 5,
    colors: {
        ...theme.colors,
        primary25: 'neutral80',
        primary: 'black',
    },
  });
export const StyleConstant = {
    customStyles,
    the
}